import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';
import React from 'react';
import TooltipStyled from './TooltipStyled';

interface Props {
  content: string;
  image?: string;
}

const Tooltip = ({content, image}: Props) => {
  if (!content) return null;
  return (
    <TooltipStyled className="ecr-tooltip">
      <div className="ecr-tooltip-wrapper">
        <div className="ecr-tooltip-popup">
          {image ? <img src={image} alt="tip" /> : null}
          <PosaTemplate Tag="div" isTemplate className="ecr-tooltip-tip" string={content} />
        </div>
        <div className="ecr-tooltip-icon">?</div>
      </div>
    </TooltipStyled>
  );
};

Tooltip.propTypes = {
  content: PropTypes.string,
  image: PropTypes.string,
};

export default Tooltip;
